module.exports = __webpack_public_path__ + "static/template_day_with_week_grid-47faa0e3ba9605e9cb2f16cc22c504d9.png";